/**
 * Created by stonewang on 2017/8/17.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Icon, Popover, Menu, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, FilterBox} from 'Components';
import {list, publishOrDownNews, showFirstPage} from '../../service/info';
import {Store, Actions} from './store';

class NoticeList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            filterBoxVisible: false,
            rows: [],
            total: 0,
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            searchObj: {
                title: '',
                isPublish: JSON.parse(window.localStorage.getItem("button_limits_end")).info_list_01 ? '' : '1',
                startDate: '',
                endDate: '',
                s: 10,
                p: 1,
                source: JSON.parse(window.localStorage.getItem("button_limits_end")).info_list_01 ? '1' : null,
            },
            loading: true,
        };
        this.getData = this.getData.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.clickHandle = this.clickHandle.bind(this);
        this.takeBack = this.takeBack.bind(this);
        this.publish = this.publish.bind(this);
        this.setTop = this.setTop.bind(this);
        this.comment = this.comment.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'info' && path[2] !== 'add') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange({...this.state.searchObj});
        } else {
            Actions.useStoreChange(false);
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params,
                }
            });
        }
    }

    componentDidMount() {
        this.getData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    goView(url) {
        hashHistory.push(url);
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        // console.log('advanceReset');
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                title: '',
                isPublish: this.state.button_limits_end.info_list_01 ? '' : '1',
                startDate: '',
                endDate: '',
                //s: 10,
                p: 1,
            }
        })
    };

    advanceSubmit(form) {
        const self = this;
        this.setState({filterBoxVisible: false, searchObj: {...this.state.searchObj, p: 1}}, function () {
            self.getData();
        });
    };

    setFilterParam(name, value) {
        // console.log(name + ':\t' + value);
        if (name === 'publishDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from,
                    endDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        const self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.getData();
        });
    }

    getData() {
        const self = this;
        const {searchObj} = this.state;
        this.setState({
            loading: true
        });
        list(searchObj).then(res => {
            if (res.status) {
                self.setState({total: res.total, rows: res.data, loading: false});
            } else {
                console.error(res.message);
                this.setState({loading: false});
            }
        });
    }

    clickHandle({item, key, keyPath}) {
        let str = key.split('_');
        this[str[0]](str[1]);
    }

    edit(id) {
        hashHistory.push(`/info/add/${id}`);
    }

    takeBack(id) {
        publishOrDownNews({ids: [id], status: 0}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        })
    }

    publish(id) {
        publishOrDownNews({ids: [id], status: 1}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        })
    }

    setTop(id) {
        showFirstPage({ids: [id], status: 1}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        })
    }

    cancelTop(id) {
        showFirstPage({ids: [id], status: 0}).then(res => {
            message[res.status ? 'success' : 'error'](res.message);
            res.status && this.getData();
        })
    }

    comment(id) {
        hashHistory.push(`/info/${id}/comment/list`);
    }

    createMenus(data) {
        const {button_limits_end} = this.state;
        const st = {margin: '-8px -16px'};
        return <div><Menu onClick={this.clickHandle} style={st}>
            <Menu.Item key={`edit_${data.id}`}>编辑</Menu.Item>
            {data.isPublish && <Menu.Item key={`takeBack_${data.id}`}>撤回</Menu.Item>}
            {!data.isPublish && <Menu.Item key={`publish_${data.id}`}>发布</Menu.Item>}
            {!data.isShow && data.isPublish && <Menu.Item key={`setTop_${data.id}`}>首页头条</Menu.Item>}
            {data.isShow && data.isPublish && <Menu.Item key={`cancelTop_${data.id}`}>取消头条</Menu.Item>}
            <Menu.Item key={`comment_${data.id}`}>查看评论</Menu.Item>
        </Menu></div>
    }

    render() {
        const {filterBoxVisible, rows, total, searchObj, button_limits_end, loading} = this.state;

        const filterBoxProps = {
            showFlag: filterBoxVisible,
            advance: {
                fileds: [
                    {
                        name: 'title',
                        label: '主题',
                        text: '输入关键词',
                        defaultValue: searchObj.title,
                        type: 'default'
                    },
                    {
                        name: 'publishDate',//startLastOperationTime, endLastOperationTime
                        label: '发布时间',
                        options: [
                            {text: '开始时间'},
                            {text: '结束时间'}
                        ],
                        defaultValue: {
                            from: searchObj.startDate || '',
                            end: searchObj.endDate || ''
                        },
                        type: 'dateComp'
                    },
                    {
                        name: 'isPublish',
                        label: '状态',
                        text: '选择状态',
                        dataType: 'number',
                        defaultValue: searchObj.isPublish !== null ? searchObj.isPublish + '' : 'null',
                        options: [
                            {value: null, text: '全部'},
                            {value: 1, text: '已发布'},
                            {value: 0, text: '已撤回'},
                        ],
                        multiple: false,//支持多选
                        type: 'select'
                    }
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            }
        };
        const tableViewProps = {
            loading: loading,
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '主题',
                    dataIndex: 'title',
                    render: (text, record, index) => {
                        return <a href={`#/info/${record.id}`}>{text}</a>
                    }
                }, {
                    title: '发布人',
                    dataIndex: 'userName'
                }, {
                    title: '发布时间',
                    dataIndex: 'publishDate',
                    render: (text) => text ? new Date(text).format('yyyy-MM-dd hh:mm') : ''
                }, {
                    title: '浏览/评论/转发',
                    dataIndex: 'commentCount',
                    render: (text, record, index) => {
                        return `${record.clickCount}/${record.commentCount}/${record.forwardCount}`
                    }
                }, {
                    title: '首页头条',
                    dataIndex: 'isShow',
                    render: text => text === 1 ? '是' : '否'
                }, {
                    title: '状态',
                    dataIndex: 'isPublish',
                    render: text => {
                        if (text === 1) {
                            return <span>
                已发布
              </span>
                        }
                        if (text === 0) {
                            return <span>
                已撤回
              </span>
                        }
                        return text;
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    className: 'alignCenter',
                    render: (text, record, index) => {
                        const menu = this.createMenus(record);
                        return <div>{button_limits_end.info_list_03 &&
                        <Popover placement="bottom" content={menu} trigger="click">
                    <span className="ant-dropdown-link">
                      <Icon type="caret-down"/>
                    </span>
                        </Popover>}</div>
                    }
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={['帮助']} defaultKey={0}>
                {button_limits_end.info_list_01 &&
                <Button icon="plus" onClick={this.goView.bind(this, `/info/add/0`)}>新增</Button>}
                {button_limits_end.info_list_02 && <Button icon="filter" onClick={this.visibleChange}>筛选</Button>}
                <FilterBox  {...filterBoxProps}/>
            </DmsTab>
            <div className="dms-table-box">
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(NoticeList);


// WEBPACK FOOTER //
// ./src/routes/info/list.js